export enum BreadcrumbActionsEnum {
    setBreadcrumbs = '[breadcrumb] setBreadcrumbs',
    unsetBreadcrumbs = '[breadcrumb] unsetBreadcrumbs',
}
